var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 96.5,
    height: 96.5,
    rx: 3.25,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5415 43.4378L66.3748 41.3545C65.604 40.9795 64.6457 41.2712 64.2707 42.042C63.8748 42.8337 64.1873 43.7712 64.9582 44.1462L68.2707 45.792V55.7712L60.4582 55.792V34.417C60.4582 30.2503 57.6665 28.167 54.2082 28.167H37.5415C34.0832 28.167 31.2915 30.2503 31.2915 34.417V68.2712H28.1665C27.3123 68.2712 26.604 68.9795 26.604 69.8337C26.604 70.6878 27.3123 71.3962 28.1665 71.3962H63.5832C64.4373 71.3962 65.1457 70.6878 65.1457 69.8337C65.1457 68.9795 64.4373 68.2712 63.5832 68.2712H60.4582V58.917L69.8332 58.8962C70.7082 58.8962 71.3957 58.1878 71.3957 57.3337V44.8337C71.3957 44.2503 71.0623 43.7087 70.5415 43.4378ZM36.4998 38.3545C36.4998 35.4587 38.2707 34.417 40.4373 34.417H51.3332C53.479 34.417 55.2498 35.4587 55.2498 38.3545V40.917C55.2498 43.792 53.479 44.8337 51.3123 44.8337H40.4373C38.2707 44.8337 36.4998 43.792 36.4998 40.8962V38.3545ZM37.5415 49.5212H43.7915C44.6457 49.5212 45.354 50.2295 45.354 51.0837C45.354 51.9378 44.6457 52.6462 43.7915 52.6462H37.5415C36.6873 52.6462 35.979 51.9378 35.979 51.0837C35.979 50.2295 36.6873 49.5212 37.5415 49.5212Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationIconView);
export default __webpack_public_path__ + "static/media/station-icon-view.930a5dcfda752262dab032baaa2c388f.svg";
export { ForwardRef as ReactComponent };